"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flex = exports.Flex = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const zeta_flex_json_1 = __importDefault(require("../idl/zeta_flex.json"));
const web3_js_1 = require("@solana/web3.js");
const types_1 = require("./types");
const types_2 = require("../common/types");
const utils = __importStar(require("../common/utils"));
const flexUtils = __importStar(require("./flex-utils"));
const program_1 = require("../common/program");
const instructions = __importStar(require("./instructions"));
const events_1 = require("../common/events");
class Flex {
    constructor() {
        this._isInitialized = false;
        this._liveAuctions = [];
        this._auctions = [];
        this._liveOptions = [];
        this._options = [];
        this._liveComboOptions = [];
        this._comboOptions = [];
        this._bids = [];
        this._underlyings = [];
    }
    /**
     * Whether the object has been loaded.
     */
    get isInitialized() {
        return this._isInitialized;
    }
    /**
     * Anchor program instance.
     */
    get program() {
        return this._program;
    }
    get programId() {
        return this._program.programId;
    }
    /**
     * The solana network being used.
     */
    get network() {
        return this._network;
    }
    /**
     * Anchor provider instance.
     */
    get provider() {
        return this._provider;
    }
    /**
     * Account storing the zeta-flex state.
     */
    get state() {
        return this._state;
    }
    /**
     * Address of the state account
     */
    get stateAddress() {
        return this._stateAddress;
    }
    /**
     * zeta-flex mint authority address
     */
    get mintAuthorityAddress() {
        return this._mintAuthorityAddress;
    }
    /**
     * zeta-flex vault authority address
     */
    get vaultAuthorityAddress() {
        return this._vaultAuthorityAddress;
    }
    /**
     * A collection of all the current live auctions on zeta-flex
     */
    get liveAuctions() {
        return this._liveAuctions;
    }
    /**
     * A collection of all auctions including historical on zeta-flex
     */
    get auctions() {
        return this._auctions;
    }
    /**
     * A collection of all current live options on zeta-flex.
     */
    get liveOptions() {
        return this._liveOptions;
    }
    /**
     * A collection of all created options on zeta-flex.
     */
    get options() {
        return this._options;
    }
    /**
     * A collection of all current live options on zeta-flex.
     */
    get liveComboOptions() {
        return this._liveComboOptions;
    }
    /**
     * A collection of all created combo options on zeta-flex.
     */
    get comboOptions() {
        return this._comboOptions;
    }
    /**
     * A collection of all the bid accounts created on zeta-flex.
     */
    get bids() {
        return this._bids;
    }
    get underlyings() {
        return this._underlyings;
    }
    /**
     * Stores the latest timestamp received by websocket subscription
     * to the system clock account.
     */
    get clockTimestamp() {
        return this._clockTimestamp;
    }
    async load(programId, network, connection, wallet = new types_2.DummyWallet(), callback) {
        if (exports.flex.isInitialized) {
            throw Error("Program already initialized");
        }
        exports.flex._network = network;
        exports.flex._provider = new anchor.AnchorProvider(connection, wallet, utils.defaultCommitment());
        exports.flex._program = new anchor.Program(zeta_flex_json_1.default, programId, exports.flex._provider);
        let [state, _stateNonce] = flexUtils.getStateAddress(this._program.programId);
        let [mintAuthority, _mintAuthNonce] = flexUtils.getMintAuthorityAddress(this._program.programId);
        let [vaultAuthority, _vaultAuthNonce] = flexUtils.getVaultAuthorityAddress(this._program.programId);
        this._stateAddress = state;
        this._vaultAuthorityAddress = vaultAuthority;
        this._mintAuthorityAddress = mintAuthority;
        await this.subscribeClock(callback);
        await this.updateState();
        exports.flex._isInitialized = true;
    }
    async initializeState(settlementPriceThresholdSeconds, mintOptionFee, feeRecipient) {
        if (!this.isInitialized) {
            throw Error("Flex not initialized yet!");
        }
        let tx = new web3_js_1.Transaction().add(await instructions.initializeStateIx(settlementPriceThresholdSeconds, mintOptionFee, feeRecipient));
        await utils.processTransaction(program_1.Program.FLEX, this._provider, tx);
        await this.updateState();
    }
    async updateStateAccount(args) {
        let tx = new web3_js_1.Transaction().add(await instructions.updateStateAccountIx({
            settlementPriceThresholdSeconds: args.settlementPriceThresholdSeconds,
            mintOptionFee: args.mintOptionFee,
            feeRecipient: args.feeRecipient,
            newAdmin: args.newAdmin,
        }));
        await utils.processTransaction(program_1.Program.FLEX, this._provider, tx);
        await this.updateState();
    }
    async initializeWhitelistFeesAccount(userToWhitelist) {
        let [whitelistFeesAccount, _whitelistNonce] = flexUtils.getWhitelistFeesAccountAddress(this.programId, userToWhitelist);
        let tx = new web3_js_1.Transaction().add(await instructions.initializeWhitelistFeesAccountIx(userToWhitelist, whitelistFeesAccount));
        await utils.processTransaction(program_1.Program.FLEX, this._provider, tx);
    }
    async initializeUnderlying(underlyingMint, oracle, underlyingType) {
        let tx = new web3_js_1.Transaction().add(await instructions.initializeUnderlyingIx(underlyingMint, oracle, underlyingType));
        await utils.processTransaction(program_1.Program.FLEX, this._provider, tx);
        await this.updateUnderlyings();
    }
    async expireOptionOverride(overrideSettlementPrice, optionAccount, optionType) {
        let tx = new web3_js_1.Transaction().add(await instructions.expireOptionOverrideIx(overrideSettlementPrice, optionAccount, optionType));
        await utils.processTransaction(program_1.Program.FLEX, this._provider, tx);
    }
    async expireOption(optionAccount, optionType) {
        let tx = new web3_js_1.Transaction().add(await instructions.expireOptionIx(optionAccount, optionType));
        await utils.processTransaction(program_1.Program.FLEX, this._provider, tx);
    }
    async updateUnderlyings() {
        let accs = await this.program.account.underlying.all();
        this._underlyings = [];
        accs.forEach((acc) => {
            let underlying = acc.account;
            this._underlyings.push({
                address: acc.publicKey,
                underlyingType: (0, types_1.toLocalUnderlyingType)(underlying.underlyingType),
                mint: underlying.mint,
                oracle: underlying.oracle,
                count: underlying.count.toNumber(),
            });
        });
    }
    getUnderlying(underlyingMint) {
        for (var i = 0; i < this._underlyings.length; i++) {
            if (this._underlyings[i].mint.equals(underlyingMint)) {
                return this._underlyings[i];
            }
        }
        return null;
    }
    async updateOptions() {
        let accs = await this.program.account.optionAccount.all();
        let options = [];
        let liveOptions = [];
        accs.forEach((acc) => {
            let [flexVaultAddress, _nonce] = flexUtils.getVaultAddress(this.programId, acc.publicKey, acc.account.vaultNonce);
            let settlementType = (0, types_1.toLocalSettlementType)(acc.account.settlementType);
            let option = {
                optionAccount: acc.publicKey,
                vault: flexVaultAddress,
                underlyingCount: acc.account.underlyingCount.toNumber(),
                optionMint: acc.account.optionMint,
                underlyingMint: acc.account.underlyingMint,
                collateralMint: acc.account.collateralMint,
                exerciseMint: acc.account.exerciseMint,
                creator: acc.account.creator,
                strike: acc.account.strike,
                expiry: settlementType == types_1.SettlementType.CASH
                    ? acc.account.expiry.settlementStart.toNumber()
                    : acc.account.expiry.settlementEnd.toNumber(),
                settlementStart: acc.account.expiry.settlementStart.toNumber(),
                settlementEnd: acc.account.expiry.settlementEnd.toNumber(),
                kind: (0, types_1.toLocalKind)(acc.account.kind),
                settlementType,
                creatorExerciseMintTokenAccount: acc.account.creatorExerciseMintTokenAccount,
                oracleMethod: (0, types_1.toLocalOracleMethod)(acc.account.oracleMethod),
                collateralAmount: Number(acc.account.collateralAmount.toString()),
                settlementPrice: Number(acc.account.settlementPrice.toString()),
                profitPerOption: Number(acc.account.profitPerOption.toString()),
                remainingCollateral: Number(acc.account.remainingCollateral.toString()),
            };
            options.push(option);
            if (this.clockTimestamp < option.expiry) {
                liveOptions.push(option);
            }
        });
        this._options = options;
        this._liveOptions = liveOptions;
        accs = await this.program.account.comboOptionAccount.all();
        let comboOptions = [];
        let liveComboOptions = [];
        accs.forEach((acc) => {
            let [flexVaultAddress, _nonce] = flexUtils.getVaultAddress(this.programId, acc.publicKey, acc.account.vaultNonce);
            let settlementType = (0, types_1.toLocalSettlementType)(acc.account.settlementType);
            let optionParams = [];
            acc.account.optionParams.forEach((op) => {
                let strike = op.strike.toNumber();
                let kind = (0, types_1.toLocalKind)(op.kind);
                let size = op.size.toNumber();
                if (strike != 0 || kind != types_1.Kind.UNDEFINED || size != 0) {
                    optionParams.push({
                        strike,
                        kind,
                        size,
                    });
                }
            });
            let comboOption = {
                optionAccount: acc.publicKey,
                vault: flexVaultAddress,
                underlyingCount: acc.account.underlyingCount.toNumber(),
                optionMint: acc.account.optionMint,
                underlyingMint: acc.account.underlyingMint,
                collateralMint: acc.account.collateralMint,
                creator: acc.account.creator,
                expiry: acc.account.expiry.settlementStart.toNumber(),
                settlementStart: acc.account.expiry.settlementStart.toNumber(),
                settlementEnd: acc.account.expiry.settlementEnd.toNumber(),
                settlementType,
                oracleMethod: (0, types_1.toLocalOracleMethod)(acc.account.oracleMethod),
                collateralAmount: Number(acc.account.collateralAmount.toString()),
                settlementPrice: Number(acc.account.settlementPrice.toString()),
                profitPerOption: Number(acc.account.profitPerOption.toString()),
                remainingCollateral: Number(acc.account.remainingCollateral.toString()),
                optionParams,
            };
            comboOptions.push(comboOption);
            if (this.clockTimestamp < comboOption.expiry) {
                liveComboOptions.push(comboOption);
            }
        });
        this._comboOptions = comboOptions;
        this._liveComboOptions = liveComboOptions;
    }
    async getSettlementAccountForOption(optionAccount, optionType) {
        let optionAccountInfo = this.getOption(optionAccount, optionType);
        let underlying = this.getUnderlying(optionAccountInfo.underlyingMint);
        let [settlementAccount, _settlementAccountNonce] = flexUtils.getSettlementAddress(this.programId, underlying.address, new anchor.BN(optionAccountInfo.expiry));
        let programSettlementAccount = await this.program.account.settlementAccount.fetch(settlementAccount);
        return {
            address: settlementAccount,
            underlyingMint: programSettlementAccount.underlyingMint,
            expectedSettlementTs: programSettlementAccount.expectedSettlementTs.toNumber(),
            actualSettlementTs: programSettlementAccount.actualSettlementTs.toNumber(),
            settlementPrice: programSettlementAccount.settlementPrice.toNumber(),
        };
    }
    async getSettlementAccount(settlementAccount) {
        let programSettlementAccount = await this.program.account.settlementAccount.fetch(settlementAccount);
        return {
            address: settlementAccount,
            underlyingMint: programSettlementAccount.underlyingMint,
            expectedSettlementTs: programSettlementAccount.expectedSettlementTs.toNumber(),
            actualSettlementTs: programSettlementAccount.actualSettlementTs.toNumber(),
            settlementPrice: programSettlementAccount.settlementPrice.toNumber(),
        };
    }
    getOption(optionAccount, optionType) {
        switch (optionType) {
            case types_1.FlexOptionType.Normal:
                for (var i = 0; i < this._options.length; i++) {
                    if (this._options[i].optionAccount.equals(optionAccount)) {
                        return this._options[i];
                    }
                }
                break;
            case types_1.FlexOptionType.Combo:
                for (var i = 0; i < this._comboOptions.length; i++) {
                    if (this._comboOptions[i].optionAccount.equals(optionAccount)) {
                        return this._comboOptions[i];
                    }
                }
                break;
        }
        return null;
    }
    getOptionByMint(optionMint, optionType) {
        switch (optionType) {
            case types_1.FlexOptionType.Normal:
                for (var i = 0; i < this._options.length; i++) {
                    if (this._options[i].optionMint.equals(optionMint)) {
                        return this._options[i];
                    }
                }
                break;
            case types_1.FlexOptionType.Combo:
                for (var i = 0; i < this._comboOptions.length; i++) {
                    if (this._comboOptions[i].optionMint.equals(optionMint)) {
                        return this._comboOptions[i];
                    }
                }
                break;
        }
        return null;
    }
    getOptionsByCreator(creator, optionType) {
        switch (optionType) {
            case types_1.FlexOptionType.Normal:
                let options = [];
                for (var i = 0; i < this._options.length; i++) {
                    if (this._options[i].creator.equals(creator)) {
                        options.push(this._options[i]);
                    }
                }
                return options;
            case types_1.FlexOptionType.Combo:
                let comboOptions = [];
                for (var i = 0; i < this._comboOptions.length; i++) {
                    if (this._comboOptions[i].creator.equals(creator)) {
                        comboOptions.push(this._comboOptions[i]);
                    }
                }
                return comboOptions;
        }
    }
    getLiveOptionsByCreator(creator, optionType) {
        switch (optionType) {
            case types_1.FlexOptionType.Normal:
                let options = [];
                for (var i = 0; i < this._liveOptions.length; i++) {
                    if (this._liveOptions[i].creator.equals(creator)) {
                        options.push(this._liveOptions[i]);
                    }
                }
                return options;
            case types_1.FlexOptionType.Combo:
                let comboOptions = [];
                for (var i = 0; i < this._liveComboOptions.length; i++) {
                    if (this._liveComboOptions[i].creator.equals(creator)) {
                        comboOptions.push(this._liveComboOptions[i]);
                    }
                }
                return comboOptions;
        }
    }
    getLiveAuctionsByCreator(creator) {
        let auctions = [];
        for (var i = 0; i < this._liveAuctions.length; i++) {
            if (this._liveAuctions[i].creator.equals(creator)) {
                auctions.push(this._liveAuctions[i]);
            }
        }
        return auctions;
    }
    getAuctionsByCreator(creator) {
        let auctions = [];
        for (var i = 0; i < this._auctions.length; i++) {
            if (this._auctions[i].creator.equals(creator)) {
                auctions.push(this._auctions[i]);
            }
        }
        return auctions;
    }
    getAuctionByKey(auctionAccount) {
        for (var i = 0; i < this._auctions.length; i++) {
            if (this._auctions[i].address.equals(auctionAccount)) {
                return this._auctions[i];
            }
        }
        return null;
    }
    getBidByKey(bidAccount) {
        for (var i = 0; i < this._bids.length; i++) {
            if (this._bids[i].address.equals(bidAccount)) {
                return this._bids[i];
            }
        }
        return null;
    }
    // TODO: rename.
    async updateBidsAndAuctions() {
        let bidAccs = await this._program.account.bidAccount.all();
        this._bids = bidAccs.map((acc) => {
            return {
                address: acc.publicKey,
                bidder: acc.account.bidder,
                amount: acc.account.amount.toNumber(),
                bidEnd: acc.account.bidEnd.toNumber(),
                cooldownEnd: acc.account.cooldownEnd.toNumber(),
                auctionAccount: acc.account.auctionAccount,
                bidVault: acc.account.bidVault,
                optionAccount: null,
                bidCurrencyMint: acc.account.bidCurrencyMint,
            };
        });
        let auctionAccs = await this.program.account.auctionAccount.all();
        let auctionBidsMap = new Map();
        // Get all the bid accounts to allocate to a specific auction.
        this._bids.forEach((bid) => {
            if (!auctionBidsMap.has(bid.auctionAccount.toString())) {
                auctionBidsMap.set(bid.auctionAccount.toString(), [bid]);
            }
            else {
                let auctionBids = auctionBidsMap.get(bid.auctionAccount.toString());
                auctionBids.push(bid);
            }
        });
        // Sort auction bids from highst to lowest
        auctionBidsMap.forEach((auctionBids, _auctionAccount) => {
            auctionBids.sort((a, b) => b.amount - a.amount);
        });
        let auctions = [];
        let liveAuctions = [];
        await Promise.all(auctionAccs.map(async (acc) => {
            let auctionAccount = acc.publicKey;
            let [auctionVault, _] = flexUtils.getAuctionVaultAddress(this.programId, acc.account.auctionTokenMint, acc.account.creator, acc.account.amount, acc.account.bidEnd, acc.account.cooldownEnd, acc.account.auctionVaultNonce);
            let optionInfo = undefined;
            for (let i = 0; i < this._options.length; i++) {
                if (this._options[i].optionMint.equals(acc.account.auctionTokenMint)) {
                    optionInfo = this._options[i];
                    break;
                }
            }
            let comboOptionInfo = undefined;
            for (let i = 0; i < this._comboOptions.length; i++) {
                if (this._comboOptions[i].optionMint.equals(acc.account.auctionTokenMint)) {
                    comboOptionInfo = this._comboOptions[i];
                }
            }
            let optionInfoToStore = undefined;
            if (optionInfo) {
                optionInfoToStore = optionInfo;
            }
            else if (comboOptionInfo) {
                optionInfoToStore = comboOptionInfo;
            }
            let bids = auctionBidsMap.get(auctionAccount.toString());
            if (bids == undefined) {
                bids = [];
            }
            let auction = {
                address: auctionAccount,
                auctionVault,
                creator: acc.account.creator,
                creatorBidCurrencyTokenAccount: acc.account.creatorBidCurrencyTokenAccount,
                amount: acc.account.amount.toNumber(),
                bidEnd: acc.account.bidEnd.toNumber(),
                cooldownEnd: acc.account.cooldownEnd.toNumber(),
                auctionTokenMint: acc.account.auctionTokenMint,
                bidCurrencyMint: acc.account.bidCurrencyMint,
                optionInfo: optionInfoToStore,
                bids,
                winningBidder: acc.account.winningBidder,
                exchangeAmount: acc.account.exchangeAmount.toNumber(),
            };
            auctions.push(auction);
            if (this.clockTimestamp < auction.cooldownEnd &&
                auction.exchangeAmount == 0 &&
                auction.winningBidder.equals(web3_js_1.PublicKey.default)) {
                liveAuctions.push(auction);
            }
        }));
        this._auctions = auctions;
        this._liveAuctions = liveAuctions;
    }
    async updateState() {
        try {
            this._state = (await this._program.account.state.fetch(this._stateAddress));
        }
        catch (e) {
            console.log("State account not initialized yet.");
        }
        await this.updateUnderlyings();
        await this.updateOptions();
        await this.updateBidsAndAuctions();
    }
    async subscribeClock(callback) {
        if (this._clockSubscriptionId !== undefined) {
            throw Error("Clock already subscribed to.");
        }
        this._clockSubscriptionId = this._provider.connection.onAccountChange(web3_js_1.SYSVAR_CLOCK_PUBKEY, async (accountInfo, _context) => {
            this._clockTimestamp = utils.getClockTimestamp(accountInfo);
            if (callback !== undefined) {
                callback(events_1.EventType.CLOCK, null);
            }
        });
        let accountInfo = await this._provider.connection.getAccountInfo(web3_js_1.SYSVAR_CLOCK_PUBKEY);
        this._clockTimestamp = utils.getClockTimestamp(accountInfo);
    }
    async close() {
        if (this._clockSubscriptionId !== undefined) {
            await this._provider.connection.removeAccountChangeListener(this._clockSubscriptionId);
            this._clockSubscriptionId = undefined;
        }
    }
}
exports.Flex = Flex;
exports.flex = new Flex();
